var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1881",
    "data-name": "Rectangle 1881",
    width: 32,
    height: 32,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1913",
    "data-name": "Rectangle 1913",
    width: 20,
    height: 17.565,
    fill: "#6639b7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4298",
    "data-name": "Groupe 4298",
    transform: "translate(-1449 -124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4295",
    "data-name": "Groupe 4295",
    transform: "translate(1449 124)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4164",
    "data-name": "Groupe 4164",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15435",
    "data-name": "Trac\\xE9 15435",
    d: "M16,2.617A13.383,13.383,0,1,1,2.616,16,13.383,13.383,0,0,1,16,2.617M16,0A16,16,0,1,0,32,16h0A16,16,0,0,0,16,0",
    transform: "translate(0 0)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15436",
    "data-name": "Trac\\xE9 15436",
    d: "M23.73,10.4A13.383,13.383,0,1,1,10.346,23.78,13.383,13.383,0,0,1,23.73,10.4",
    transform: "translate(-7.696 -7.734)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4297",
    "data-name": "Groupe 4297",
    transform: "translate(1455 131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4296",
    "data-name": "Groupe 4296",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15485",
    "data-name": "Trac\\xE9 15485",
    d: "M17.484,14.256a1.054,1.054,0,0,0-1.393.53,6.675,6.675,0,0,1-12.058.26l.6.266A1.054,1.054,0,1,0,5.5,13.393l-.015-.007L2.714,12.152a1.053,1.053,0,0,0-1.391.534L.088,15.459a1.054,1.054,0,0,0,1.925.857L2.154,16A8.781,8.781,0,0,0,10,20.837h.153a8.782,8.782,0,0,0,7.861-5.187,1.054,1.054,0,0,0-.528-1.394h0",
    transform: "translate(0 -3.272)",
    fill: "#6639b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15486",
    "data-name": "Trac\\xE9 15486",
    d: "M20.094,3.989a1.053,1.053,0,0,0-1.391.534l-.141.316a8.782,8.782,0,0,0-15.828.28A1.054,1.054,0,0,0,4.648,6,6.675,6.675,0,0,1,16.683,5.8l-.6-.266a1.054,1.054,0,0,0-.857,1.925l2.765,1.231H18a1.054,1.054,0,0,0,1.393-.53l1.234-2.773a1.053,1.053,0,0,0-.534-1.391Z",
    transform: "translate(-0.717 0)",
    fill: "#6639b7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon_refresh.f38860822db0f3b771a3a6b07c31ab1d.svg";
export { ForwardRef as ReactComponent };